<template>
  <div class="subpackage-payment-approval">
    <!-- 顶部标题栏 -->
    <div class="title-bar">
      {{ paymentTypeTitle }}
    </div>

    <!-- 基本信息 -->
    <div class="header">
      <img :src="icon1" alt="" />
      <span>基本信息</span>
    </div>
    <div class="panel">
      <div class="label">申请人</div>
      <div class="value1">{{ extra.applicantName || '--' }}</div>
      
      <div class="label">申请部门</div>
      <div class="value2">{{ extra.deptName || '--' }}</div>
      
      <div class="label">申请时间</div>
      <div class="value3">{{ detail.startTime || '--' }}</div>
    </div>

    <Padding />

    <!-- 项目信息 -->
    <div class="header">
      <img :src="icon2" alt="" />
      <span>项目信息</span>
    </div>
    <div class="panel">
      <div class="label">项目名称</div>
      <div class="value1">{{ contractInfo.name || '--' }}</div>
      
      <div class="label">设计编号</div>
      <div class="value2">{{ contractInfo.code || '--' }}</div>
      
      <div class="label">购方名称</div>
      <div class="value3">{{ contractInfo.partyAname || '--' }}</div>
      
      <div class="label">合同金额(元)</div>
      <div class="value1">{{ $numberFormat(contractInfo.contractAmount) || '--' }}</div>
      
      <div class="label">累计回款金额(元)</div>
      <div class="value2">{{ $numberFormat(contractInfo.finCumulativeReceivedAmount) || '0' }}</div>
      
      <div class="label">回款比例</div>
      <div class="value3">{{ (contractInfo.finCumulativeReceivedRatio || '0') + '%' }}</div>
    </div>

    <Padding />

    <!-- 分包信息 -->
    <div class="header">
      <img :src="icon3" alt="" />
      <span>分包信息</span>
    </div>
    <div class="panel">
      <div class="label">分包名称</div>
      <div class="value1">{{ subpackageInfo.name || '--' }}</div>
      
      <div class="label">分包类型</div>
      <div class="value2">
        <DataDictFinder
          v-if="subpackageInfo.isneeded === 1"
          dictType="subType"
          :dictValue="subpackageInfo.type"
        />
        <DataDictFinder
          v-if="subpackageInfo.isneeded === 0"
          dictType="notNeedSubType"
          :dictValue="subpackageInfo.type"
        />
        <DataDictFinder
          v-if="subpackageInfo.isneeded === 2"
          dictType="generalSubType"
          :dictValue="subpackageInfo.type"
        />
        <template v-if="subpackageInfo.major">
          <span> - </span>
          <DataDictFinder dictType="majorTypes" :dictValue="subpackageInfo.major" />
        </template>
      </div>
      
      <div class="label">分包公司</div>
      <div class="value3">{{ subpackageInfo.companyName || '--' }}</div>
      
      <div class="label">预计分包金额(元)</div>
      <div class="value1">{{ $numberFormat(subpackageInfo.planAmount) || '--' }}</div>
      
      <div class="label">分包付款比例</div>
      <div class="value2">{{ (subpackageInfo.finPaymentRatio || 0) + '%' }}</div>
      
      <div class="label">已支付金额(元)</div>
      <div class="value3">{{ $numberFormat(subpackageInfo.finPaymentAmount) || '0' }}</div>
      
      <div class="label">增值税税率</div>
      <div class="value1">{{ (subpackageInfo.vatRate || 0) + '%' }}</div>
      
      <div class="label">分包状态</div>
      <div class="value2">
        <DataDictFinder dictType="taskReviewStatus" :dictValue="subpackageInfo.status" iconType="badge" />
      </div>
    </div>

    <Padding />

    <!-- 付款信息 -->
    <div class="header">
      <img :src="icon4" alt="" />
      <span>付款信息</span>
    </div>
    <div class="panel">
      <div class="label">本次支付金额(元)</div>
      <div class="value1">
        <span class="amount-highlight">{{ $numberFormat(extra.currentPaymentAmount) || '--' }}</span>
      </div>
      
      <div class="label">支付主体</div>
      <div class="value2">{{ paymentSubjectName || '--' }}</div>
      
      <div class="label">累计支付金额(含本次)(元)</div>
      <div class="value3">{{ $numberFormat(paymentInfo.totalPaymentAmount) || '--' }}</div>
      
      <div class="label">累计支付比例(含本次)</div>
      <div class="value1">{{ (paymentInfo.totalPaymentRatio || 0) + '%' }}</div>
      
      <div class="label">是否超额支付</div>
      <div class="value2">
        <a-tag :color="paymentInfo.isOverpayment ? 'red' : 'green'">
          {{ paymentInfo.isOverpayment ? '是' : '否' }}
        </a-tag>
      </div>
      
      <div class="label">是否取得发票</div>
      <div class="value3">
        <a-tag :color="paymentInfo.isInvoiceObtained ? 'green' : 'orange'">
          {{ paymentInfo.isInvoiceObtained ? '是' : '否' }}
        </a-tag>
      </div>
      
      <div class="label">收款方银行账户名称</div>
      <div class="value1">{{ extra.receiverBankAccountName || '--' }}</div>
      
      <div class="label">收款方银行账号</div>
      <div class="value2">{{ paymentInfo.receiverBankAccount || '--' }}</div>
      
      <div class="label">收款方开户银行</div>
      <div class="value3">{{ paymentInfo.receiverBankName || '--' }}</div>
      
      <div class="label">付款说明</div>
      <div class="value3 desc">{{ extra.paymentDescription || '--' }}</div>
    </div>

    <Padding />

    <!-- 申请材料 -->
    <div class="header">
      <img :src="icon5" alt="" />
      <span>申请材料</span>
    </div>
    <div class="panel">
      <div class="label">附件列表</div>
      <div class="value3">
        <div v-if="Array.isArray(attachmentList) && attachmentList.length > 0">
          <a 
            v-for="(item, index) in attachmentList" 
            :key="index" 
            target="_blank" 
            :href="item.completePath"
            style="display:block; margin-bottom: 8px;"
          >
            <a-icon type="file" />
            {{ item.name || $getFileName(item.completePath) }}
          </a>
        </div>
        <div v-else class="empty-text">暂无附件</div>
      </div>
    </div>

    <Padding />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { replaceUrl } from "@/api/approval";
import DataDictFinder from "@/components/data-dict-finder";
import icon1 from "@/assets/approval1.png";
import icon2 from "@/assets/approval2.png";
import icon3 from "@/assets/contract-register/icon-subpackage.png";
import icon4 from "@/assets/approval4.png";
import icon5 from "@/assets/approval5.png";

export default {
  name: "SubpackagePaymentApproval",
  components: {
    DataDictFinder
  },
  data() {
    return {
      icon1,
      icon2,
      icon3,
      icon4,
      icon5,
      fileListWithPrivateUrl: []
    };
  },
  computed: {
    ...mapState("approval", ["detail"]),
    
    // extra 数据
    extra() {
      if (this.detail && this.detail.extra) {
        // 如果 extra 是字符串，需要解析
        if (typeof this.detail.extra === 'string') {
          try {
            return JSON.parse(this.detail.extra);
          } catch (e) {
            console.error('解析 extra 数据失败:', e);
            return {};
          }
        }
        return this.detail.extra;
      }
      return {};
    },
    
    // 付款类型标题
    paymentTypeTitle() {
      const paymentType = this.extra.paymentType;
      if (paymentType === 'prod_institute') {
        return '总院项目付款申请单';
      } else if (paymentType === 'branch_institute') {
        return '分院项目付款申请单';
      }
      return '项目付款申请单'; // 默认标题
    },
    
    // 合同信息 - 从 extra.contract 中获取基本信息，使用镜像数据作为回款信息
    contractInfo() {
      // 基本信息优先从 contract 对象获取
      let name = '--';
      let code = '--';
      let partyAname = '--';
      let contractAmount = 0;
          
      if (this.extra.contract) {
        const contract = typeof this.extra.contract === 'string' 
          ? JSON.parse(this.extra.contract) 
          : this.extra.contract;
        name = contract.name || '--';
        code = contract.code || '--';
        partyAname = contract.partyAname || '--';
        contractAmount = contract.contractAmount || 0;
      } else {
        // 兜底：从 extra 直接获取
        name = this.extra.contractName || '--';
        code = this.extra.contractCode || '--';
        partyAname = this.extra.ownerName || '--';
        contractAmount = this.extra.snapshotContractAmount || 0;
      }
          
      // 累计回款金额和比例使用镜像数据
      return {
        name,
        code,
        partyAname,
        contractAmount,
        finCumulativeReceivedAmount: this.extra.snapshotCumulativeCollectionAmount || 0,
        finCumulativeReceivedRatio: this.extra.snapshotCollectionRatio || '0'
      };
    },
    
    // 分包信息
    subpackageInfo() {
      if (this.extra.sub) {
        try {
          return typeof this.extra.sub === 'string' 
            ? JSON.parse(this.extra.sub) 
            : this.extra.sub;
        } catch (e) {
          console.error('解析 sub 失败:', e);
          return {};
        }
      }
      
      // 从 businessKey 中可能包含分包ID，但需要额外的 API 调用获取详情
      // 这里先返回空对象，实际使用时可能需要根据 businessKey 查询分包详情
      return {
        id: this.extra.subpackageId || this.extra.id,
        name: this.extra.subpackageName || '--',
        companyName: this.extra.companyName || '--'
      };
    },
    
    // 付款信息
    paymentInfo() {
      return {
        totalPaymentAmount: this.extra.snapshotCumulativePaymentAmount || 0,
        totalPaymentRatio: this.extra.snapshotCumulativePaymentRatio || 0,
        isOverpayment: this.extra.isOverpayment || false,
        isInvoiceObtained: this.extra.isInvoiceObtained || false,
        receiverBankAccount: this.extra.receiverBankAccount || '--',
        receiverBankName: this.extra.receiverBankName || '--'
      };
    },
    
    // 支付主体名称
    paymentSubjectName() {
      // 使用 paymentSubjectName 字段
      return this.extra.paymentSubjectName || '--';
    },
    
    // 附件列表（带私有链接）
    attachmentList() {
      return this.fileListWithPrivateUrl;
    }
  },
  watch: {
    detail: {
      deep: true,
      handler(val) {
        if (val?.extra) {
          this.refreshFileList();
        }
      },
      immediate: true
    }
  },
  methods: {
    // 刷新附件列表，获取私有链接
    refreshFileList() {
      const extra = this.extra;
      if (extra.applicationMaterialFileList && Array.isArray(extra.applicationMaterialFileList) && extra.applicationMaterialFileList.length > 0) {
        // 获取所有文件的公开链接
        const publicUrls = extra.applicationMaterialFileList.map(item => item.completePath).join(',');
        
        replaceUrl({
          publicUrls: publicUrls
        }).then((data) => {
          // data 是逗号分隔的私有链接
          const privateUrls = data.split(',');
          // 组合文件名和私有链接
          this.fileListWithPrivateUrl = extra.applicationMaterialFileList.map((item, index) => ({
            name: item.name,
            completePath: privateUrls[index] || item.completePath
          }));
        }).catch(() => {
          // 如果获取失败，使用原始链接
          this.fileListWithPrivateUrl = extra.applicationMaterialFileList;
        });
      } else {
        this.fileListWithPrivateUrl = [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
.subpackage-payment-approval {
  .title-bar {
    text-align: center;
    padding: 20px 0;
    font-size: 24px;
    font-weight: bold;
    color: #262626;
    border-bottom: 2px solid #1890ff;
    margin-bottom: 20px;
    background-color: #fff;
  }

  .header {
    display: flex;
    align-items: center;
    padding: 12px 0;
    font-weight: bold;
    font-size: 17px;
    
    img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }

  .panel {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    border-top: 1px solid #e8e8e8;
    background-color: #fff;

    & > div {
      padding: 12px 8px;
      border-bottom: 1px solid #e8e8e8;
      font-size: 14px;
    }

    .label {
      background-color: #fafafa;
      border-right: 1px solid #e8e8e8;
      border-left: 1px solid #e8e8e8;
      font-weight: 500;
      color: #262626;
    }

    .value1 {
      grid-column-start: 2;
      grid-column-end: 4;
      color: #595959;
    }

    .value2 {
      grid-column-start: 5;
      grid-column-end: 7;
      border-right: 1px solid #e8e8e8;
      color: #595959;
    }

    .value3 {
      grid-column-start: 2;
      grid-column-end: 7;
      border-right: 1px solid #e8e8e8;
      color: #595959;
    }

    .amount-highlight {
      color: #ff4d4f;
      font-weight: bold;
      font-size: 16px;
    }

    .desc {
      word-break: break-all;
      white-space: pre-wrap;
      line-height: 1.8;
    }

    .empty-text {
      color: #8c8c8c;
      font-size: 13px;
    }
  }
}
</style>